import React, { useState, useEffect, useContext } from 'react';
import {Stack, Icon, FormLayout} from '@shopify/polaris';
import {SearchMinor, DeleteMajor} from '@shopify/polaris-icons';
import {FormContext, useFetch} from '@thinkwell/react.common';
import {EditModal, TextField, Checkbox, Select, Autocomplete} from '@thinkwell/react.polaris';
import {CoursesContext} from '../contexts/Courses'

export default function EditCourseForm(props) {
  const item = props.item || {}

  const form = useContext(FormContext)

  return (<FormLayout>
      <Autocomplete
        name="product_id"
        label="Product"
        value={item.product && item.product.name}
        url={`${window.location.origin}/products.json?limit=50`}
        valueProp="name"
      />
      <TextField required
        label="Name"
        name="name"
      />
      <TextField
        label="Video Player Path (Flash)"
        name="player_path"
      />
      <TextField
        type="number"
        label="Maple Parent ID"
        name="mapleta_parent_id"
      />
      <Checkbox
        label="Stand alone videos"
        name="stand_alone_video"
      />
      <Checkbox
        label="Lock video dimensions"
        name="lock_video_dimensions"
      />
      <TextField
        label="Theme"
        name="theme"
      />
      <TextField
        multiline={4}
        label="Changelog"
        name="changelog"
      />
    </FormLayout>
  );
}
